
  (function () {
    const mfKey = '__module_federation__containers';
    window[mfKey] = window[mfKey] || {};
    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] || {
      get: async (cmpId) => {
        const importFn = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'][cmpId];
        const Component = await importFn();
        return () => Component;
      },
      init: async () => {
        
      },
    };

    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362']['bf8ff2f5-6575-4657-b53e-bfe71b9d1d2e'] = () => import('/src/dashboard/pages/wix-products/page.tsx');
  })();